import URL from '../url'
import Request from '../request'
import { getPortalPageEditing } from 'src/utils/portal-page-editing'

export const collectionListService = query =>
  new Request(URL.API, URL.COLLECTION_LIST).post(query)
/**
 *@param {*} collectionName
 *
 */
export const createCourseCollectionService = entity =>
  new Request(URL.API, URL.CREATE_COURSE_COLLECTION).post(entity)

export const getCourseCollectionService = id =>
  new Request(URL.API, URL.COLLECTION_GET.replace('{id}', id)).get()

/**
 *@param {*} id
 *
 */
export const deleteCollectionService = id =>
  new Request(URL.API, URL.DELETE_COURSE_COLLECTION).delete({ id })

export const getCollectionCourseListService = id =>
  new Request(
    URL.API,
    URL.COLLECTION_COURSE_LIST.replace('{collectionId}', id),
  ).get()

/**
 *
 * @param {*} entity
 */
export const editCourseCollectionIndexService = entity =>
  new Request(URL.API, URL.EDIT_ASSIGNMENT_COURSE_COLLECTION_INDEX).put(entity)

/**
 *
 * @param {*} id
 */
export const getCollectionSettingsService = id =>
  new Request(
    URL.API,
    URL.GET_COLLECTION_TEAM_LIST + '/' + id + URL.GET_COLLECTION_SETTINGS,
  ).get()

/**
 *
 * @param {*} content
 */
export const patchCollectionSettingsService = content =>
  new Request(
    URL.API,
    URL.GET_COLLECTION_TEAM_LIST +
      '/' +
      content.id +
      URL.GET_COLLECTION_SETTINGS,
  ).patch(content)

/**
 * Sends a test email through the provider saved on the collection's settings.
 * @param {*} collectionId
 * @param {*} recipient optional; defaults to the signed-in user server-side
 */
export const sendCollectionTestEmailService = (collectionId, recipient) =>
  new Request(
    URL.API,
    URL.GET_COLLECTION_TEAM_LIST +
      '/' +
      collectionId +
      URL.SEND_COLLECTION_TEST_EMAIL,
  ).post({ recipient: recipient || null })

/**
 *
 * @param {*} content
 */
export const patchPriceService = (id, data) =>
  new Request(URL.API, URL.COLLECTION_PRICE.replace('{id}', id)).put(data)

export const patchCollectionPaymentMessagesService = (collectionId, content) =>
  new Request(
    URL.API,
    URL.PATCH_COLLECTION_PAYMENT_MESSAGES.replace(
      '{collectionId}',
      collectionId,
    ),
  ).patch(content)
/**
 *
 *
 */
export const patchCourseCollectionService = content =>
  new Request(URL.API, URL.PATCH_COLLECTION + '?id=' + content.id).patch(
    content,
  )

// While a portal page is open in the landing page editor, the editor's landing
// page requests go to that page (see utils/portal-page-editing).
const portalPageContentUrl = () => {
  const page = getPortalPageEditing()
  return page
    ? URL.SHOP_LANDING_PAGE_PAGE_CONTENT.replace('{id}', page.pageId)
    : null
}

export const getCollectionLandingPageService = id =>
  new Request(
    URL.API,
    portalPageContentUrl() ||
      URL.GET_COLLECTION_LANDING_PAGE.replace('{id}', id),
  ).get()

/**
 * @param {*} id
 * @param {*} query
 */
export const collectionMemberFilterService = (id, query) =>
  new Request(URL.API, URL.COLLECTION_MEMBERS_LIST.replace('{id}', id)).post(
    query,
  )

export const landingPagePatchService = (id, data) =>
  new Request(
    URL.API,
    portalPageContentUrl() ||
      URL.PATCH_COLLECTION_LANDING_PAGE.replace('{id}', id),
  ).patch(data)

export const inviteCollaboratorService = (id, data) =>
  new Request(URL.API, URL.COLLECTION_INVITE_MEMBER.replace('{id}', id)).post(
    data,
  )

export const getCollectionCollaboratorsListService = (id, query) =>
  new Request(
    URL.API,
    URL.COLLECTION_COLLABORATORS_LIST.replace('{id}', id),
  ).post(query)

export const updateCollectionCollaboratorService = (id, userId, data) =>
  new Request(
    URL.API,
    URL.COLLECTION_UPDATE_COLLABORATOR.replace('{id}', id).replace(
      '{userId}',
      userId,
    ),
  ).put(data)

export const deleteCollectionCollaboratorService = (id, userId) =>
  new Request(
    URL.API,
    URL.COLLECTION_DELETE_COLLABORATOR.replace('{id}', id).replace(
      '{userId}',
      userId,
    ),
  ).delete()

export const filterCollaborationsService = query =>
  new Request(URL.API, URL.COLLECTION_FILTER_COLLABORATIONS).post(query)

export const acceptInvitationCollaborationService = code =>
  new Request(URL.API, URL.COLLECTION_ACCEPT_INVITATION_COLLABORATION).post({
    code: code,
  })

export const deleteCollectionInvitationService = (id, email) =>
  new Request(
    URL.API,
    URL.COLLECTION_DELETE_INVITATION.replace('{id}', id).replace(
      '{email}',
      email,
    ),
  ).delete()

export const collectionShowcaseService = data =>
  new Request(URL.API, URL.COLLECTION_SHOWCASE).post(data)

export const setCollectionTagsService = (id, tagIds) =>
  new Request(URL.API, URL.COLLECTION_SET_TAGS.replace('{id}', id)).put({
    tagIds,
  })

/**
 * The workspace portal for a workspace key: its showcase id and custom domain.
 */
export const portalResolveService = shopKey =>
  new Request(URL.API, URL.PORTAL_RESOLVE).get({ shopKey })

/** The workspace portal: menu, header, footer, SEO and its pages. */
export const shopLandingPageGetService = () =>
  new Request(URL.API, URL.SHOP_LANDING_PAGE).get()

/** Saves menu, header, footer and SEO; send the whole set. */
export const shopLandingPageUpdateService = data =>
  new Request(URL.API, URL.SHOP_LANDING_PAGE).put(data)

/** Adds a custom page: { name, slug, showInMenu }. */
export const portalPageCreateService = data =>
  new Request(URL.API, URL.SHOP_LANDING_PAGE_PAGES).post(data)

/** Renames a page; custom pages can also change their slug. */
export const portalPageUpdateService = (id, data) =>
  new Request(URL.API, URL.SHOP_LANDING_PAGE_PAGE.replace('{id}', id)).put(data)

export const portalPageDeleteService = id =>
  new Request(URL.API, URL.SHOP_LANDING_PAGE_PAGE.replace('{id}', id)).delete()

/** { available, message } for a custom page slug. */
export const portalPageSlugCheckService = (slug, pageId) =>
  new Request(URL.API, URL.SHOP_LANDING_PAGE_SLUG_CHECK).get(
    pageId ? { slug, pageId } : { slug },
  )
